// Themed text input with Link's strawberry focus ring and pastel border.

import { forwardRef, type InputHTMLAttributes } from "react";

import { cn } from "../lib/cn";

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type, ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        "ui-glass-input flex h-10 w-full rounded-lg border border-strawberry-100 bg-white/80 px-3 py-2 text-sm text-cloud-700 ring-offset-background placeholder:text-cloud-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";
